import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { E404Component } from './modules/core/e404/e404.component';
import { PageComponent } from './modules/pages/page/page.component';
import { CoverArtPageComponent } from './modules/coverart/coverart-page/coverart-page.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: './modules/homepage/homepage.module#HomepageModule'
  },
  {
    path: '404',
    component: E404Component
  },
  {
    path: 'archive',
    loadChildren: './modules/archive/archive.module#ArchiveModule',
  },
  {
    path: 'artists',
    loadChildren: './modules/artists/artists.module#ArtistsModule',
  },
  {
    path: 'artworks',
    loadChildren: './modules/coverart/coverart.module#CoverArtModule',
  },
  {
    path: 'artworks/:coverArtId',
    component: CoverArtPageComponent,
  },
  {
    path: 'chat',
    loadChildren: './modules/chat/chat.module#ChatModule',
  },
  {
    path: ':pageSlug',
    component: PageComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      scrollPositionRestoration: 'enabled'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
